import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';
import { KalDate } from '@kalidea/kaligraphi';
import { ChampListeValeurDto } from 'src/graphql/generated-types';
import { CritereModel, DataTypes } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import {
    getDataTypeFromString
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-criterion-value-control/shared-advanced-rule-criterion-value-control.component';

@Component({
    selector: 'app-shared-advanced-rule-criterion-value-detail',
    templateUrl: './shared-advanced-rule-criterion-value.component.html',
    styleUrls: ['./shared-advanced-rule-criterion-value.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedRuleCriterionValueComponent {

    @Input()
    value: string | boolean | number | KalDate = null;

    DataTypes = DataTypes;

    dataType = DataTypes.Number;

    availableValues: ChampListeValeurDto[] = [];

    constructor(private readonly cdr: ChangeDetectorRef) {
    }

    @Input()
    set criterion(value: CritereModel) {
        if (!value) {
            this.dataType = DataTypes.Number;
            this.availableValues = [];
            return;
        }

        this.dataType = getDataTypeFromString(value.TypeDonnee?.Code);
        this.availableValues = value?.Champ?.ListChampListeValeur?.ChampListeValeurDTO || [];
        this.cdr.markForCheck();
    }

}
